import { Box } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import instagramLogo from "../assets/social/instagram.svg";
import twitterLogo from "../assets/social/twitter.png";
import linkedinLogo from "../assets/social/linkedin.png";

type TeamMemberProps = {
  image: string;
  name: string;
  role: string;
  social?: {
    instagram?: string;
    twitter?: string;
    linkedin?: string;
  };
};
const TeamMember = ({ image, name, role, social }: TeamMemberProps) => {
  return (
    <Box>
      <img
        src={image}
        alt={name}
        className="gallery-img"
        style={{ margin: 0, height: "auto", width: "95%" }}
      ></img>
      <h4>{name}</h4>
      <h5>{role}</h5>
      <Box display={"flex"} justifyContent={"center"}>
        {social?.instagram && (
          <a href={social?.instagram} target="_blank" rel="noopener noreferrer">
            <img
              src={instagramLogo}
              alt="instagram"
              className="social-logo-team-member"
            />
          </a>
        )}
        {social?.twitter && (
          <a href={social?.twitter} target="_blank" rel="noopener noreferrer">
            <img
              src={twitterLogo}
              alt="twitter"
              className="social-logo-team-member"
            />
          </a>
        )}
        {social?.linkedin && (
          <a href={social?.linkedin} target="_blank" rel="noopener noreferrer">
            <img
              src={linkedinLogo}
              alt="linkedin"
              className="social-logo-team-member"
            />
          </a>
        )}
      </Box>
    </Box>
  );
};

export default TeamMember;
